import React, { useMemo } from 'react';
import { BookingPill } from '../../BookingPill';
import { StatusMenu } from '../StatusMenu';
import { formatWallMin } from '../../../lib/availability';
import {
  colourFor,
  statusClassFor,
  fmtRange,
} from '../../../lib/diary/helpers';

// ===== DAY VIEW =====
// rowHeights drives the variable per-hour label + gridline heights so
// expanded rows stay perfectly aligned with the cards positioned by
// `eventStyle` (which closes over the parent's `topForMin`).
export const DayView = ({
  bookings, hours, rowHeights, scrollRef, eventStyle,
  isFirstForCustomer, nowTop, onStatusChanged, onOpenBooking,
  isBarber, myBarberId, myPerms, focusBookingId,
}) => {
  const laid = useMemo(() => {
    const sorted = [...bookings].sort((a,b) => new Date(a.starts_at) - new Date(b.starts_at));
    const lanes = [];
    return sorted.map(b => {
      const start = new Date(b.starts_at).getTime();
      const end = new Date(b.ends_at).getTime();
      let lane = lanes.findIndex(e => e <= start);
      if (lane === -1) { lane = lanes.length; lanes.push(end); }
      else lanes[lane] = end;
      return { b, lane, lanesUsed: lanes.length };
    });
  }, [bookings]);
  const laneCount = Math.max(1, ...laid.map(x => x.lanesUsed));

  return (
    <div className="cal" data-testid="cal-day" ref={scrollRef}>
      <div className="cal-head" style={{ gridTemplateColumns: `56px 1fr` }}>
        <div></div>
        <div>All barbers</div>
      </div>
      <div className="cal-grid" style={{ gridTemplateColumns: `56px 1fr` }}>
        <div className="hours">
          {hours.map((h, i) => (
            <div key={h} className="hr" style={{ height: `${rowHeights[i]}px` }}>{h}</div>
          ))}
        </div>
        <div className="laneset">
          <div className="lane-bg">{hours.map((h, i) => (
            <div key={h} className="slot" style={{ height: `${rowHeights[i]}px` }} />
          ))}</div>
          {laid.map(({ b, lane }) => {
            const s = eventStyle(b);
            const widthPct = 100 / laneCount;
            const nowTs = Date.now();
            const isRunning =
              new Date(b.starts_at).getTime() <= nowTs &&
              new Date(b.ends_at).getTime()   >  nowTs;
            const h = Number(String(s.height || '0').replace('px','')) || 0;
            const tight = h < 60 ? ' ev-tight' : '';
            const verytight = h < 40 ? ' ev-verytight' : '';
            return (
              <div
                key={b.id}
                className={`ev${tight}${verytight} ${colourFor(b, isFirstForCustomer(b))}${focusBookingId === b.id ? ' ev-focus' : ''}${isRunning ? ' running' : ''} ${statusClassFor(b)}`}
                style={{ ...s, left: `calc(${lane * widthPct}% + 5px)`, width: `calc(${widthPct}% - 10px)`, right: 'auto' }}
                data-testid={`ev-${b.id}`}
                onClick={() => onOpenBooking?.(b.id)}
              >
                <div className="ev-body">
                  <span className="ev-time">{fmtRange(b, formatWallMin)}</span>
                  <b className="ev-name">{b.customer?.name}</b>
                  <small className="ev-svc">{b.service?.name}</small>
                </div>
                <div className="ev-aside">
                  <BookingPill booking={b} testIdSuffix={b.id} />
                  <StatusMenu
                    booking={b}
                    onChanged={onStatusChanged}
                    canManage={!isBarber || b.barber_id === myBarberId}
                    perms={isBarber ? myPerms : undefined}
                  />
                </div>
              </div>
            );
          })}
        </div>
      </div>
      {nowTop !== null && <div className="nowline" style={{ top: nowTop + 41 }} data-testid="cal-nowline" />}
    </div>
  );
};
